module.exports = __webpack_public_path__ + "static/media/jump.677e7bff.png";